import React from 'react'
import { Outlet } from 'react-router-dom'
import { ROLE } from '../../enum/role'
import { connect } from 'react-redux'

const OtaUpload = (props) => {
  if (!(props.userRole === ROLE['ADMIN'])) {
		return (
			  <div>
            <h1>Unauthorized Access</h1>
            <p>You do not have the necessary permissions to access this page.</p>
        </div>
		)
	}
  return (
    <div className='ota-upload-details'>
      <Outlet/>
    </div>
  )
}
const mapStateToProps = (state) => {
  return {
      userRole: state.userDetails.userRole
  }
};


const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(OtaUpload);
